// extracted by mini-css-extract-plugin
export var closeButton = "video-modal-module--close-button--9d84f";
export var modal = "video-modal-module--modal--16d6d";